import React from "react";
import { CheckIcon, CloseIcon } from "../../assets";
import styles from "./styles.module.scss";

export default function DeclineButton() {
  return <div className={styles.declineButton}>{<CloseIcon fill="white" />}</div>;
}
